/* i18n : traductions injectees par layout/theme.liquid (window.PP_I18N).
   PP_T(cle, repli FR, params) : la cle pp.js.<cle> si elle existe, sinon le repli ;
   les jetons {{ nom }} sont remplaces par params.nom (ex. {{ amount }}, {{ count }}).
   Definition UNIQUE du theme, exposee sur window.PP_T : parapharm.js (charge apres,
   en defer) la reutilise et ne doit jamais la redefinir. */
function PP_T(k, d, p) {
  var s = (window.PP_I18N && window.PP_I18N[k]) || d || '';
  if (p) {
    Object.keys(p).forEach(function (n) {
      /* remplacement par fonction : un « $ » dans la valeur n'est pas interprete par replace() */
      s = s.replace(new RegExp('\\{\\{\\s*' + n + '\\s*\\}\\}', 'g'), function () { return String(p[n]); });
    });
  }
  return s;
}
window.PP_T = PP_T;
/* PERMATAN theme JS v1.6 - vanilla, sans dependance externe.
   Galerie media produit (vignettes, clavier, defilement mobile, zoom),
   selecteur de variante + achat direct 1 clic (ajout au panier puis /checkout,
   le permalien /cart/<variante>:1 ne sert que de repli sans JS : il REMPLACE le
   panier, D4-2), drawer panier AJAX (progression livraison offerte + cross-sell,
   ouverture par [data-cart-link] et [data-cart-open], compteur [data-cart-count]),
   menu mobile plein ecran, rotation barre d'annonce mobile, toast, FAQ, sticky bar,
   comparateur avant/apres, quantites page panier. */
(function () {
  'use strict';

  /* ---------- Utils ---------- */

  function formatMoneyCents(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* Racine de la locale courante (window.PP_RACINE = routes.root_url : « / » en FR,
     « /es » ou « /en » sinon). Tous les appels AJAX du panier et les liens /cart doivent
     en etre prefixes, sinon Shopify repond dans la langue par defaut (titres produits
     en francais dans le tiroir sur /es/ et /en/). */
  function ppRoot() {
    var r = window.PP_RACINE;
    return (r && r !== '/') ? String(r).replace(/\/$/, '') : '';
  }

  function showToast(message, isError) {
    var old = document.querySelector('.pmt-toast');
    if (old) old.remove();
    var toast = document.createElement('div');
    toast.className = 'pmt-toast';
    toast.setAttribute('role', 'status');
    var ico = document.createElement('span');
    ico.className = 'pmt-toast-ico' + (isError ? ' err' : '');
    ico.innerHTML = isError
      ? '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>'
      : '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
    var txt = document.createElement('span');
    txt.textContent = message;
    toast.appendChild(ico);
    toast.appendChild(txt);
    document.body.appendChild(toast);
    setTimeout(function () { toast.remove(); }, 2600);
  }

  /* Compteur du panier de l'en-tete (contrat pp-header : <span data-cart-count>) : texte,
     classe is-empty et attribut hidden quand le panier est vide. Appele a CHAQUE changement
     de panier (ajout, quantite, retrait). */
  function updateCartCount(count) {
    var n = parseInt(count, 10) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', !n);
      if (n) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    document.querySelectorAll('[data-cart-link], [data-cart-open]').forEach(function (link) {
      link.setAttribute('aria-label', PP_T('cart_view', "Voir le panier") + ' (' + n + ')');
    });
  }

  function fetchCart() {
    return fetch(ppRoot() + '/cart.js').then(function (r) { return r.json(); });
  }

  /* ---------- Piege de focus (drawer + menu mobile) ---------- */

  function trapFocus(container, e) {
    var focusables = container.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ---------- Drawer panier ---------- */

  var drawer = null;
  var drawerLastFocus = null;

  function drawerEl() {
    if (drawer === null) drawer = document.querySelector('[data-cart-drawer]') || false;
    return drawer;
  }

  function openDrawer() {
    var d = drawerEl();
    if (!d) return false;
    drawerLastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = d.querySelector('.cdrawer-close');
    if (closeBtn) closeBtn.focus();
    return true;
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (drawerLastFocus && drawerLastFocus.focus) drawerLastFocus.focus();
  }

  function renderDrawer(cart) {
    var d = drawerEl();
    if (!d) return;
    var lines = d.querySelector('[data-drawer-lines]');
    var empty = d.querySelector('[data-drawer-empty]');
    var foot = d.querySelector('[data-drawer-foot]');
    var countEl = d.querySelector('[data-drawer-count]');
    var totalEl = d.querySelector('[data-drawer-total]');
    if (!lines) return;

    lines.textContent = '';
    var hasItems = cart.items && cart.items.length > 0;
    if (empty) empty.hidden = hasItems;
    if (foot) foot.style.display = hasItems ? '' : 'none';
    if (countEl) countEl.textContent = hasItems ? '(' + cart.item_count + ')' : '';
    if (totalEl) totalEl.textContent = formatMoneyCents(cart.total_price);

    /* Barre de progression livraison offerte */
    var freeShipRaw = parseInt(d.getAttribute('data-free-ship'), 10);
    var freeShip = isNaN(freeShipRaw) ? 4900 : freeShipRaw; /* 0 = pas de livraison offerte */
    var shipLabel = d.querySelector('[data-drawer-ship-label]');
    var shipBar = d.querySelector('[data-drawer-ship-bar]');
    var shipWrap = d.querySelector('[data-drawer-ship-bar-wrap]');
    var shipBox = d.querySelector('[data-drawer-ship]');
    if (shipBox) shipBox.style.display = hasItems ? '' : 'none';
    if (shipLabel && shipBar && !freeShip) {
      shipLabel.textContent = PP_T('ship_std', "Expédié sous 24 à 48 h ouvrées · Colissimo suivi");
      if (shipWrap) shipWrap.style.display = 'none';
    } else if (shipLabel && shipBar) {
      var pctShip = Math.min(100, Math.round((cart.total_price / freeShip) * 100));
      shipBar.style.width = pctShip + '%';
      if (shipWrap) shipWrap.setAttribute('aria-valuenow', pctShip);
      if (cart.total_price >= freeShip) {
        shipLabel.textContent = PP_T('ship_free_cart', '🎉 Livraison Colissimo offerte !');
        shipLabel.classList.add('is-free');
      } else {
        shipLabel.textContent = PP_T('ship_next', 'Plus que {{ amount }} pour la livraison offerte', { amount: formatMoneyCents(freeShip - cart.total_price) });
        shipLabel.classList.remove('is-free');
      }
    }

    /* Lignes du panier */
    if (hasItems) {
      cart.items.forEach(function (item) {
        var line = document.createElement('div');
        line.className = 'cdrawer-line';

        var imgBox = document.createElement('div');
        imgBox.className = 'cdrawer-line-img';
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2');
          img.alt = item.product_title || '';
          img.width = 60;
          img.height = 60;
          img.loading = 'lazy';
          imgBox.appendChild(img);
        }
        line.appendChild(imgBox);

        var info = document.createElement('div');
        info.className = 'cdrawer-line-info';
        var title = document.createElement('span');
        title.className = 'cdrawer-line-title';
        title.textContent = item.product_title;
        info.appendChild(title);
        if (item.variant_title && item.variant_title !== 'Default Title') {
          var variant = document.createElement('span');
          variant.className = 'cdrawer-line-variant';
          variant.textContent = item.variant_title;
          info.appendChild(variant);
        }

        var bottom = document.createElement('div');
        bottom.className = 'cdrawer-line-bottom';
        var qty = document.createElement('div');
        qty.className = 'cdrawer-qty';
        var dec = document.createElement('button');
        dec.type = 'button';
        dec.textContent = '−';
        dec.setAttribute('aria-label', PP_T('qty_minus', "Diminuer la quantité de") + ' ' + item.product_title);
        var num = document.createElement('span');
        num.textContent = item.quantity;
        num.setAttribute('aria-live', 'polite');
        var inc = document.createElement('button');
        inc.type = 'button';
        inc.textContent = '+';
        inc.setAttribute('aria-label', PP_T('qty_plus', "Augmenter la quantité de") + ' ' + item.product_title);
        qty.appendChild(dec);
        qty.appendChild(num);
        qty.appendChild(inc);
        bottom.appendChild(qty);
        var price = document.createElement('span');
        price.className = 'cdrawer-line-price';
        price.textContent = formatMoneyCents(item.final_line_price);
        var capUnit = (window.PPD_COMPARE || {})[String(item.variant_id)];
        var capLine = capUnit ? capUnit * item.quantity : 0;
        if (capLine > item.original_line_price) {
          var cross = document.createElement('s');
          cross.className = 'cdrawer-line-compare';
          cross.style.cssText = 'font-size:12px;color:var(--mut,#5A7571);margin-right:6px;align-self:center';
          cross.textContent = formatMoneyCents(capLine);
          bottom.appendChild(cross);
        }
        bottom.appendChild(price);
        info.appendChild(bottom);
        if (capLine > item.original_line_price) {
          var save = document.createElement('span');
          save.className = 'cdrawer-line-save';
          save.style.cssText = 'display:block;font-size:11.5px;font-weight:600;color:var(--pmt-green,#0C4A48);margin-top:2px;text-align:right';
          save.textContent = PP_T('you_save', "Vous économisez") + ' ' + formatMoneyCents(capLine - item.original_line_price);
          info.appendChild(save);
        }

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'cdrawer-remove';
        remove.textContent = PP_T('remove', "Retirer");
        remove.setAttribute('aria-label', PP_T('remove', "Retirer") + ' ' + item.product_title);
        info.appendChild(remove);

        line.appendChild(info);
        lines.appendChild(line);

        dec.addEventListener('click', function () { changeLine(item.key, item.quantity - 1); });
        inc.addEventListener('click', function () { changeLine(item.key, item.quantity + 1); });
        remove.addEventListener('click', function () { changeLine(item.key, 0); });
      });
    }

    /* Cross-sell : masque les accessoires deja au panier */
    var inCart = {};
    (cart.items || []).forEach(function (item) { inCart[String(item.variant_id)] = true; });
    var crossBox = d.querySelector('[data-drawer-cross]');
    if (crossBox) {
      var visibleCross = 0;
      crossBox.querySelectorAll('[data-cross-item]').forEach(function (ci) {
        var hidden = !!inCart[ci.getAttribute('data-cross-vid')];
        ci.classList.toggle('is-hidden', hidden);
        if (!hidden) visibleCross++;
      });
      crossBox.style.display = hasItems && visibleCross > 0 ? '' : 'none';
    }

    updateCartCount(cart.item_count);
  }

  function changeLine(key, quantity) {
    fetch(ppRoot() + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(renderDrawer)
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || PP_T('update_failed', "Mise à jour impossible.");
        showToast(msg, true);
      });
  }

  function initDrawer() {
    var d = drawerEl();
    if (!d || d.dataset.pmtBound) return;
    d.dataset.pmtBound = '1';

    d.querySelectorAll('[data-drawer-close], [data-drawer-close-link]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (el.hasAttribute('data-drawer-close')) e.preventDefault();
        closeDrawer();
      });
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); }
      if (e.key === 'Tab' && d.classList.contains('is-open')) trapFocus(d.querySelector('.cdrawer-panel'), e);
    });
    d.querySelectorAll('[data-drawer-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart(btn.getAttribute('data-variant-id'), btn.getAttribute('data-item-name'), btn, true);
      });
    });

    /* Le lien panier du header ([data-cart-link], et [data-cart-open] du contrat pp-header)
       ouvre le drawer ; sans drawer (settings.enable_drawer decoche : initDrawer sort plus
       haut) ou sans JS, le lien suit son href vers /cart. */
    document.querySelectorAll('[data-cart-link], [data-cart-open]').forEach(function (link) {
      if (link.dataset.pmtBound) return;
      link.dataset.pmtBound = '1';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCart().then(function (cart) {
          renderDrawer(cart);
          openDrawer();
        }).catch(function () { window.location.href = link.getAttribute('href'); });
      });
    });
  }

  /* ---------- Ajout panier ---------- */

  function addToCart(variantId, name, btn, keepDrawer, quantity) {
    if (!variantId) return;
    if (btn) btn.disabled = true;
    fetch(ppRoot() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Math.max(1, parseInt(quantity, 10) || 1) }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(fetchCart)
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (drawerEl()) {
          renderDrawer(cart);
          if (!keepDrawer) openDrawer();
        } else {
          showToast(PP_T('added', "Ajouté au panier") + ' · ' + (name || PP_T('item', "article")));
        }
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || PP_T('add_failed', "Impossible d’ajouter cet article.");
        showToast(msg, true);
      })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  /* ---------- Galerie media produit (snippet product-gallery) ---------- */

  function initGallery(g) {
    if (g.dataset.pmtBound) return;
    g.dataset.pmtBound = '1';
    var stage = g.querySelector('[data-gallery-stage]');
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-thumb]'));
    var mobile = window.matchMedia('(max-width: 759px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var scrollTimer = null;
    var programmatic = false;

    function idOf(el) { return el.getAttribute('data-media-id'); }
    function activeSlide() {
      for (var i = 0; i < slides.length; i++) { if (slides[i].classList.contains('is-active')) return slides[i]; }
      return null;
    }
    /* Diapositives navigables : les medias du produit, plus l'image de repli tant qu'elle est affichee. */
    function navigable() {
      return slides.filter(function (s) { return idOf(s) !== 'asset' || s.classList.contains('is-active'); });
    }

    function show(id, opts) {
      opts = opts || {};
      id = String(id);
      var target = null;
      slides.forEach(function (s) {
        var on = idOf(s) === id;
        s.classList.toggle('is-active', on);
        if (on) target = s;
        if (!on) {
          s.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) { /* noop */ } });
        }
      });
      if (!target) return false;
      thumbs.forEach(function (t) {
        var on = idOf(t) === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on && opts.focus) t.focus();
        /* Vignette active ramenee dans sa bande, sans jamais faire defiler la page
           (scrollIntoView ferait sauter la page au chargement si la galerie est sous la ligne de flottaison). */
        if (on) {
          var wrap = t.parentElement;
          if (wrap) {
            if (wrap.scrollWidth > wrap.clientWidth) wrap.scrollLeft = t.offsetLeft - (wrap.clientWidth - t.offsetWidth) / 2;
            else if (wrap.scrollHeight > wrap.clientHeight) wrap.scrollTop = t.offsetTop - (wrap.clientHeight - t.offsetHeight) / 2;
          }
        }
      });
      if (stage && mobile.matches && !opts.fromScroll) {
        programmatic = true;
        try {
          stage.scrollTo({ left: target.offsetLeft, behavior: reduced.matches ? 'auto' : 'smooth' });
        } catch (e) { stage.scrollLeft = target.offsetLeft; }
        setTimeout(function () { programmatic = false; }, 600);
      }
      return true;
    }

    function step(delta, focus) {
      var list = navigable();
      if (!list.length) return;
      var cur = activeSlide();
      var idx = Math.max(0, list.indexOf(cur));
      var next = list[(idx + delta + list.length) % list.length];
      show(idOf(next), { focus: focus });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(idOf(t)); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); step(1, true); }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); step(-1, true); }
        else if (e.key === 'Home') { e.preventDefault(); var l = navigable(); if (l.length) show(idOf(l[0]), { focus: true }); }
        else if (e.key === 'End') { e.preventDefault(); var m = navigable(); if (m.length) show(idOf(m[m.length - 1]), { focus: true }); }
      });
    });
    var prev = g.querySelector('[data-gallery-prev]');
    var next = g.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    /* Mobile : le defilement horizontal met a jour la vignette active. */
    if (stage) {
      stage.addEventListener('scroll', function () {
        if (!mobile.matches || programmatic) return;
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var best = null, bestDist = Infinity;
          navigable().forEach(function (s) {
            var d = Math.abs(s.offsetLeft - stage.scrollLeft);
            if (d < bestDist) { bestDist = d; best = s; }
          });
          if (best && !best.classList.contains('is-active')) show(idOf(best), { fromScroll: true });
        }, 80);
      }, { passive: true });
    }

    /* Zoom au clic : boite de dialogue native. */
    var dialog = g.querySelector('[data-gallery-dialog]');
    if (dialog && typeof dialog.showModal === 'function') {
      var dImg = dialog.querySelector('[data-gallery-dialog-img]');
      var dClose = dialog.querySelector('[data-gallery-dialog-close]');
      g.querySelectorAll('[data-gallery-zoom-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-zoom-src');
          var inner = btn.querySelector('img');
          if (dImg) {
            dImg.src = src || (inner ? (inner.currentSrc || inner.src) : '');
            dImg.alt = inner ? (inner.alt || '') : '';
          }
          dialog.showModal();
        });
      });
      if (dClose) dClose.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', function () { if (dImg) dImg.removeAttribute('src'); });
    }

    g.pgShow = show;
    g.pgHas = function (id) {
      id = String(id);
      return slides.some(function (s) { return idOf(s) === id; });
    };
  }

  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
  }

  /* ---------- Buy box (selecteur de variante + achat direct) ---------- */

  function initBuyBox(box) {
    if (box.dataset.pmtBound) return;
    box.dataset.pmtBound = '1';
    var dataEl = box.querySelector('[data-buybox-data]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });

    var radios = Array.prototype.slice.call(box.querySelectorAll('[data-variant-radio]'));
    var gallery = box.querySelector('[data-gallery]');
    if (gallery) initGallery(gallery);
    var stageImg = box.querySelector('[data-stage-img]');
    var stageVol = box.querySelector('[data-stage-vol]');
    var shipNote = box.querySelector('[data-ship-note]');
    var stockNote = box.querySelector('[data-stock-note]');
    var buyNow = box.querySelector('[data-buy-now]');
    var buyLabel = box.querySelector('[data-buy-label]');
    var buyPrice = box.querySelector('[data-buy-price]');
    var atcBtn = box.querySelector('[data-atc-main]');
    var atcLabel = box.querySelector('[data-atc-label]');

    var sticky = document.querySelector('[data-stickybar="' + (box.getAttribute('data-buybox') || '') + '"]');
    var stName = sticky ? sticky.querySelector('[data-sticky-name]') : null;
    var stUnit = sticky ? sticky.querySelector('[data-sticky-unit]') : null;
    var stPrice = sticky ? sticky.querySelector('[data-sticky-price]') : null;
    var stOld = sticky ? sticky.querySelector('[data-sticky-old]') : null;
    var stSave = sticky ? sticky.querySelector('[data-sticky-save]') : null;
    var stBuy = sticky ? sticky.querySelector('[data-sticky-buy]') : null;

    var FREE_SHIP_RAW = parseInt(box.getAttribute('data-free-ship'), 10);
    var FREE_SHIP = isNaN(FREE_SHIP_RAW) ? 4900 : FREE_SHIP_RAW; /* 0 = pas de livraison offerte */
    var current = null;

    function apply(v) {
      if (!v) return;
      current = v;
      radios.forEach(function (r) {
        r.setAttribute('aria-checked', r.getAttribute('data-vid') === String(v.id) ? 'true' : 'false');
      });
      /* Visuel : la featured_media de la variante si la galerie la contient,
         sinon l'image d'asset par SKU (repli, diapositive [data-stage-img]). */
      var shown = false;
      if (gallery && gallery.pgShow && v.media_id !== null && v.media_id !== undefined && gallery.pgHas(v.media_id)) {
        shown = gallery.pgShow(v.media_id);
      }
      if (!shown && stageImg) {
        var fallbackSrc = v.media_url || v.img;
        if (fallbackSrc) {
          if (stageImg.getAttribute('src') !== fallbackSrc) stageImg.setAttribute('src', fallbackSrc);
          stageImg.setAttribute('alt', v.title);
          if (gallery && gallery.pgShow) gallery.pgShow('asset');
        }
      }
      if (stageVol) stageVol.textContent = v.vol;
      if (shipNote) {
        if (!FREE_SHIP) {
          shipNote.textContent = PP_T('ship_fast', "Expédition rapide, en colis neutre et discret");
        } else if (v.price >= FREE_SHIP) {
          shipNote.textContent = PP_T('ship_free', 'Livraison Colissimo offerte');
        } else {
          var remain = Math.ceil((FREE_SHIP - v.price) / 100);
          shipNote.textContent = PP_T('ship_next', 'Plus que {{ amount }} pour la livraison offerte', { amount: remain + ' €' });
        }
      }
      if (stockNote) {
        if (v.available && typeof v.qty === 'number' && v.qty > 0 && v.qty <= 10) {
          stockNote.textContent = PP_T('stock_left', 'Plus que {{ count }} en stock', { count: v.qty });
          stockNote.hidden = false;
        } else {
          stockNote.hidden = true;
        }
      }
      if (buyNow) {
        if (v.available) {
          buyNow.setAttribute('href', ppRoot() + '/cart/' + v.id + ':1');
          buyNow.removeAttribute('aria-disabled');
          buyNow.removeAttribute('tabindex');
          if (buyLabel) buyLabel.textContent = PP_T('buy_now', "Acheter maintenant") + ' · ';
          if (buyPrice) buyPrice.textContent = v.price_f;
        } else {
          buyNow.setAttribute('aria-disabled', 'true');
          buyNow.setAttribute('tabindex', '-1');
          if (buyLabel) buyLabel.textContent = PP_T('sold_out', "Rupture de stock");
          if (buyPrice) buyPrice.textContent = '';
        }
      }
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? PP_T('atc', "Ajouter au panier") : PP_T('sold_out', "Rupture de stock");
      }
      if (stName) stName.textContent = v.name || v.title;
      if (stUnit) stUnit.textContent = v.unit_short ? ' · ' + v.unit_short : '';
      if (stPrice) stPrice.textContent = v.price_f;
      if (stOld) {
        stOld.textContent = v.compare_f || '';
        stOld.style.display = v.compare_f ? '' : 'none';
      }
      if (stSave) {
        stSave.textContent = v.save_pct ? '−' + v.save_pct + ' %' : '';
        stSave.style.display = v.save_pct ? '' : 'none';
      }
      if (stBuy) {
        if (v.available) {
          stBuy.setAttribute('href', ppRoot() + '/cart/' + v.id + ':1');
          stBuy.removeAttribute('aria-disabled');
          stBuy.removeAttribute('tabindex');
        } else {
          stBuy.setAttribute('aria-disabled', 'true');
          stBuy.setAttribute('tabindex', '-1');
        }
      }
    }

    radios.forEach(function (r) {
      r.addEventListener('click', function () {
        var v = byId[r.getAttribute('data-vid')];
        if (v) apply(v);
      });
      r.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); r.click(); }
      });
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (current && current.available) addToCart(current.id, current.title, atcBtn);
      });
    }

    /* Achat direct (D4-2) : le href /cart/<variante>:1 est un permalien qui REMPLACE le
       panier (un accessoire deja ajoute disparaissait au paiement). Ici la variante est
       AJOUTEE au panier existant, puis le paiement s'ouvre. Le href reste le repli sans
       JavaScript ; sans fetch, le navigateur suit le lien. Echec d'ajout (stock, reseau) :
       message, pas de navigation. */
    var buyBusy = false;
    function directCheckout(e, link) {
      if (!current || !current.available) { e.preventDefault(); return; }
      if (!window.fetch) return;
      e.preventDefault();
      if (buyBusy) return;
      buyBusy = true;
      link.setAttribute('aria-busy', 'true');
      fetch(ppRoot() + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(current.id), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (er) { throw er; });
          return r.json();
        })
        .then(function () { window.location.assign(ppRoot() + '/checkout'); })
        .catch(function (err) {
          buyBusy = false;
          link.removeAttribute('aria-busy');
          showToast((err && (err.description || err.message)) || PP_T('add_failed', "Impossible d’ajouter cet article."), true);
        });
    }
    if (buyNow) buyNow.addEventListener('click', function (e) { directCheckout(e, buyNow); });
    if (stBuy) stBuy.addEventListener('click', function (e) { directCheckout(e, stBuy); });

    var initial = box.querySelector('[data-variant-radio][aria-checked="true"]') || radios[0];
    if (initial) apply(byId[initial.getAttribute('data-vid')]);
  }

  /* ---------- Boutons add-to-cart directs (tarifs, accessoires) ---------- */

  function initDirectAtc() {
    document.querySelectorAll('[data-atc]').forEach(function (btn) {
      if (btn.dataset.pmtBound) return;
      btn.dataset.pmtBound = '1';
      btn.addEventListener('click', function () {
        addToCart(btn.getAttribute('data-variant-id'), btn.getAttribute('data-item-name'), btn);
      });
    });
    /* Form B2B « Ajouter au panier (tarif professionnel) » : ajout AJAX + aperçu du panier
       dans le drawer au lieu de la redirection pleine page vers /cart.
       Messages et nom de l'article : attributs data-* poses par le Liquid (buy-box),
       lus avec getAttribute (entites HTML decodees). min / max : attributs du champ. */
    document.querySelectorAll('form[data-b2b-atc]').forEach(function (form) {
      if (form.dataset.pmtBound) return;
      form.dataset.pmtBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var qtyInput = form.querySelector('[name="quantity"]');
        var qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        var min = parseInt(qtyInput && qtyInput.min, 10) || 1;
        var max = parseInt(qtyInput && qtyInput.max, 10) || 0;
        if (qty < min) { showToast(form.getAttribute('data-b2b-min-msg') || PP_T('b2b_min', "Tarif professionnel : commande minimum") + ' ' + min, true); return; }
        if (max > 0 && qty > max) { showToast(form.getAttribute('data-b2b-max-msg') || PP_T('max_pre', "Maximum") + ' ' + max, true); return; }
        var idInput = form.querySelector('[name="id"]');
        addToCart(idInput && idInput.value, form.getAttribute('data-item-name') || PP_T('item', "article"), form.querySelector('button[type="submit"]'), false, qty);
      });
    });
  }

  /* ---------- Menu mobile (hamburger) ---------- */

  function initMobileNav() {
    var burger = document.querySelector('[data-burger]');
    var mnav = document.querySelector('[data-mnav]');
    if (!burger || !mnav || burger.dataset.pmtBound) return;
    burger.dataset.pmtBound = '1';
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      mnav.classList.add('is-open');
      mnav.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', PP_T('menu_close', 'Fermer le menu'));
      document.body.style.overflow = 'hidden';
      var closeBtn = mnav.querySelector('.mnav-close');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      mnav.classList.remove('is-open');
      mnav.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', PP_T('menu_open', 'Ouvrir le menu'));
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      else burger.focus();
    }

    burger.addEventListener('click', function () {
      if (mnav.classList.contains('is-open')) close(); else open();
    });
    mnav.querySelectorAll('[data-mnav-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    mnav.querySelectorAll('[data-mnav-link]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    mnav.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab' && mnav.classList.contains('is-open')) trapFocus(mnav.querySelector('.mnav-panel'), e);
    });
  }

  /* ---------- Barre d'annonce : rotation mobile ---------- */

  var tbarTimer = null;
  function initTbarRotation() {
    var tbar = document.querySelector('[data-tbar]');
    if (!tbar) return;
    var slides = Array.prototype.slice.call(tbar.querySelectorAll('[data-tbar-slide]'));
    if (slides.length < 2) return;
    var mq = window.matchMedia('(max-width: 640px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var idx = 0;

    function start() {
      if (tbarTimer) return;
      tbar.classList.add('tbar--rotate');
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === 0); });
      idx = 0;
      tbarTimer = setInterval(function () {
        slides[idx].classList.remove('is-active');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('is-active');
      }, 3800);
    }
    function stop() {
      if (tbarTimer) { clearInterval(tbarTimer); tbarTimer = null; }
      tbar.classList.remove('tbar--rotate');
      slides.forEach(function (s) { s.classList.remove('is-active'); });
    }
    function sync() {
      if (mq.matches && !reduced.matches) start(); else stop();
    }
    if (!tbar.dataset.pmtBound) {
      tbar.dataset.pmtBound = '1';
      if (mq.addEventListener) {
        mq.addEventListener('change', sync);
        reduced.addEventListener('change', sync);
      }
    }
    sync();
  }

  /* ---------- FAQ accordeon ---------- */

  function initFaq() {
    document.querySelectorAll('.faq-item').forEach(function (item) {
      var q = item.querySelector('.faq-q');
      if (!q) return;
      if (q.dataset.pmtBound) return;
      q.dataset.pmtBound = '1';
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        var parent = item.parentElement;
        if (parent) {
          parent.querySelectorAll('.faq-item.is-open').forEach(function (o) {
            o.classList.remove('is-open');
            var b = o.querySelector('.faq-q');
            if (b) b.setAttribute('aria-expanded', 'false');
            var t = o.querySelector('.faq-toggle');
            if (t) t.textContent = '+';
          });
        }
        if (!open) {
          item.classList.add('is-open');
          q.setAttribute('aria-expanded', 'true');
          var t = item.querySelector('.faq-toggle');
          if (t) t.textContent = '−';
        }
      });
    });
  }

  /* ---------- Sticky bar mobile (apparait apres le hero) ---------- */

  var stickyBound = false;
  function initSticky() {
    var onScroll = function () {
      var hero = document.querySelector('.pp1') || document.querySelector('.hero');
      var threshold = hero ? hero.offsetTop + hero.offsetHeight - 60 : 480;
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      document.querySelectorAll('[data-stickybar]').forEach(function (b) { b.classList.toggle('is-visible', y > threshold); });
    };
    if (!stickyBound) {
      stickyBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
    onScroll();
  }

  /* ---------- Comparateur avant / apres ---------- */

  function initBeforeAfter() {
    document.querySelectorAll('[data-ba]').forEach(function (wrap) {
      if (wrap.dataset.pmtBound) return;
      wrap.dataset.pmtBound = '1';
      var before = wrap.querySelector('[data-ba-before]');
      var line = wrap.querySelector('.ba-line');
      var knob = wrap.querySelector('.ba-knob');
      var dragging = false;
      var pos = 50;

      function setPos(p) {
        pos = Math.max(0, Math.min(100, p));
        if (before) before.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
        if (line) line.style.left = pos + '%';
        if (knob) knob.style.left = pos + '%';
        wrap.setAttribute('aria-valuenow', Math.round(pos));
      }
      function setFromClientX(clientX) {
        var r = wrap.getBoundingClientRect();
        setPos(((clientX - r.left) / r.width) * 100);
      }
      wrap.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { wrap.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
        setFromClientX(e.clientX);
      });
      wrap.addEventListener('pointermove', function (e) { if (dragging) setFromClientX(e.clientX); });
      wrap.addEventListener('pointerup', function () { dragging = false; });
      wrap.addEventListener('pointercancel', function () { dragging = false; });
      /* Accessibilite clavier */
      if (!wrap.hasAttribute('tabindex')) wrap.setAttribute('tabindex', '0');
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); setPos(pos - 4); }
        if (e.key === 'ArrowRight') { e.preventDefault(); setPos(pos + 4); }
      });
    });
  }

  /* ---------- Page panier (fallback) : boutons quantite, minimum revendeur ---------- */

  function initCartPage() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;
    if (form.dataset.pmtBound) return;
    form.dataset.pmtBound = '1';
    /* Garde-fou revendeur (meme regle que le serveur PayPal) : le total de FLACONS du
       produit principal (packs eclates : data-units = 2 pour un pack de 2) doit
       atteindre data-b2b-min. Message : data-b2b-min-msg (Liquid, locale), lu par
       getAttribute qui decode les entites HTML. Les mises a jour de quantite passent
       par form.submit(), qui ne declenche pas l'evenement submit : elles restent libres. */
    var b2bMin = parseInt(form.getAttribute('data-b2b-min'), 10) || 0;
    if (b2bMin > 0) {
      form.addEventListener('submit', function (e) {
        var total = 0;
        form.querySelectorAll('.qty-input[data-main="1"]').forEach(function (inp) {
          var units = parseInt(inp.getAttribute('data-units'), 10) || 1;
          var val = parseInt(inp.value, 10) || 0;
          if (val > 0) total += val * units;
        });
        if (total > 0 && total < b2bMin) {
          e.preventDefault();
          var msg = form.getAttribute('data-b2b-min-msg') || (PP_T('b2b_min', "Tarif professionnel : commande minimum") + ' ' + b2bMin);
          alert(msg);
        }
      });
    }
    form.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var box = btn.closest('.qty-box');
        var input = box ? box.querySelector('.qty-input') : null;
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        val += btn.getAttribute('data-qty-change') === 'inc' ? 1 : -1;
        input.value = Math.max(1, val);
        form.submit();
      });
    });
    form.querySelectorAll('.qty-input').forEach(function (input) {
      input.addEventListener('change', function () { form.submit(); });
    });
  }

  /* ---------- Init ---------- */

  function init() {
    initDrawer();
    initGalleries();
    document.querySelectorAll('[data-buybox]').forEach(initBuyBox);
    initDirectAtc();
    initMobileNav();
    initTbarRotation();
    initFaq();
    initSticky();
    initBeforeAfter();
    initCartPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Editeur de theme : re-init apres re-rendu d'une section
     (les elements deja lies sont proteges par data-pmt-bound). */
  document.addEventListener('shopify:section:load', init);
  /* API exposée pour parapharm.js (section pp-formats) */
  window.PMT = { addToCart: addToCart, openDrawer: openDrawer, showToast: showToast, formatMoneyCents: formatMoneyCents, fetchCart: fetchCart };
})();

